import baseApi from "./baseApi";
import axios from "axios";



const getCompany = () => axios.get("company/Companies", { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const updateCompany = (r) => axios.put(`company/userprofile`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });

export default {
    getCompany,
    updateCompany
};